import { render, staticRenderFns } from "./RegisterResource.vue?vue&type=template&id=e7c6f1c4&"
import script from "./RegisterResource.vue?vue&type=script&lang=js&"
export * from "./RegisterResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports